import { render, staticRenderFns } from "./items-per-term.vue?vue&type=template&id=18e0afa5&scoped=true&"
import script from "./items-per-term.vue?vue&type=script&lang=js&"
export * from "./items-per-term.vue?vue&type=script&lang=js&"
import style0 from "./items-per-term.vue?vue&type=style&index=0&id=18e0afa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e0afa5",
  null
  
)

component.options.__file = "items-per-term.vue"
export default component.exports